<div class="modal-body">
  <p class="centermodal__title text-center mb-4">{{ 'shared.certificateData' | translate }}</p>
  <p class="centermodal__description mb-3">
    {{ 'shared.certificateDescription' | translate }}
  </p>

  <div class="certificate">
    <div class="certificate-box">
      <p class="certificate-category__title">Subject</p>
      @for (entry of subject | keyvalue; track entry.key) {
        @if (entry.value) {
          <p class="certificate-category__value">{{ entry.key }}={{ entry.value }}</p>
        }
      }
    </div>

    <div class="certificate-box">
      <p class="certificate-category__title">Issuer</p>
      @for (entry of issuer | keyvalue; track entry.key) {
        @if (entry.value) {
          <p class="certificate-category__value">{{ entry.key }}={{ entry.value }}</p>
        }
      }
    </div>
    <div class="certificate-box">
      <p class="certificate-category__title">Validity</p>
      @for (entry of validity | keyvalue; track entry.key) {
        @if (entry.value) {
          <p class="certificate-category__value">{{ entry.key }}={{ entry.value }}</p>
        }
      }
    </div>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" (click)="modal.dismiss()">
      {{ 'button.close' | translate }}
    </button>
  </div>
</div>
